import { has, isNil, pick } from '../../../utils/fp';
import { getOrder } from './annotations';

const applyConstraintsToValues = (values, constraintsSet, key) =>
  values.map(val => {
    const hasData = isNil(constraintsSet) || constraintsSet.has(val.id);
    return {
      ...val,
      [key]: hasData,
    };
  });

export const applyConstraintsToDimensions = (dimensions, constraints = {}, key = 'hasData') =>
  dimensions.map(dim => {
    const dimConstraints = constraints[dim.id];
    const hasData = isNil(dimConstraints) || !!dimConstraints?.size;
    const values = applyConstraintsToValues(dim.values, dimConstraints, key);
    return {
      ...dim,
      values,
      [key]: hasData,
    };
  });

const refineDimensionValues = values =>
  values.map((val, ind) => {
    const order = getOrder(val.annotations);
    return {
      ...pick(['id', 'name', 'description'], val),
      order,
      parentId: val.parent,
      position: ind,
    };
  });

const refineDimension = (dim, hiddenValues) => {
  const isHidden = has(dim.id, hiddenValues);
  const values = refineDimensionValues(dim.values || []);
  return {
    ...dim,
    display: !isHidden,
    values,
  };
};

export const refineDimensions = (dimensions, hiddenValues) =>
  dimensions.map(dim => refineDimension(dim, hiddenValues));
